import { useEffect, useState } from "react";
import {
  SistemaCadastroDto,
  SistemaFiltrarDto,
  SubModuloEnum,
  TipoConfiguracaoEnum,
} from "../../Configuracoes/Sistema/Sistema.Dto";
import { useNavigate } from "react-router-dom";
import { AutenticacaoModule } from "src/Contexto/auth";
import { ConfiguracaoFiltrar } from "src/services/Fiscal.Service";
import { showToast } from "src/componentes";

const NFeConfiguracaoCode = () => {
  const [configuracao, setConfiguracao] = useState<SistemaCadastroDto[]>([]);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { userId } = AutenticacaoModule();

  const CACHE_KEY = "nfeConfiguracoes" + userId;
  const CACHE_EXPIRATION_TIME = 30 * 60 * 1000;

  useEffect(() => {
    const controller = new AbortController();
    const Load = async () => {
      const cachedData = localStorage.getItem(CACHE_KEY);

      if (cachedData) {
        const parsedData = JSON.parse(cachedData);
        const currentTime = new Date().getTime();

        if (currentTime - parsedData.timestamp < CACHE_EXPIRATION_TIME) {
          setConfiguracao(parsedData.data);
          return;
        } else {
          localStorage.removeItem(CACHE_KEY);
        }
      }
      const input: SistemaFiltrarDto = {
        subModulo: SubModuloEnum.NFe,
        usuarioId: userId.toString(),
      };

      await ConfiguracaoFiltrar(input)
        .then((response) => {
          if (response.data.success) {
            const data = response.data.data as SistemaCadastroDto[];
            const cacheObject = {
              data,
              timestamp: new Date().getTime(),
            };
            if (validarConfiguracoes(data)) {
              navigate("/inicio");
            } else {
              localStorage.setItem(CACHE_KEY, JSON.stringify(cacheObject));

              setConfiguracao(data);
            }
          } else {
            console.error(response);
          }
        })
        .finally(() => {
          setLoading(false);
        });
    };
    Load();
    return () => {
      controller.abort();
    };
  }, []);

  function validarConfiguracoes(data: SistemaCadastroDto[]): boolean {
    const obrigatorias = [
      {
        tipo: TipoConfiguracaoEnum.Serie,
        mensagem: "Configure série para o usuário para emissão de NFe",
      },
    ];

    for (const obrigatoria of obrigatorias) {
      const item = data.find(
        (item) => String(item.tipoConfiguracao) === String(obrigatoria.tipo)
      );
      if (
        !item ||
        !item.configuracaoValor ||
        item.configuracaoValor.trim() === ""
      ) {
        showToast({
          message: obrigatoria.mensagem,
          title: "Erro - Sistema não configurado",
          variant: "Danger",
        });
        return true;
      }
    }

    return false;
  }

  function getConfiguracaoValor(tipoConfiguracao: string | number) {
    const item = configuracao.find(
      (item) => String(item.tipoConfiguracao) === String(tipoConfiguracao)
    );
    return item?.configuracaoValor ?? "";
  }

  return {
    loading,
    getConfiguracaoValor,
  };
};

export default NFeConfiguracaoCode;
